/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import useTimeElapsed from '../../hooks/useTimeElapsed/useTimeElapsed'
import { CheckCircleIcon } from '../../assets/icons/CheckCircleIcon'
import { ChevronArrowDownIcon } from '../../assets/icons/ChevronArrowDownIcon'
import { CloseIcon } from '../../assets/icons/CloseIcon'
import { LockIcon } from '../../assets/icons/LockIcon'
import { TimesCircleIcon } from '../../assets/icons/TimesCircleIcon'
import { BUTTON_STYLE_PAUTA } from '../../libraries/ButtonTheme'
import {
  getStatusClassName,
  PautaStatusType,
  STATUS_PAUTA_ENCERRADA,
  STATUS_PAUTA_LIBERADA
} from '../../libraries/Pautas'
import { RADIO_BUTTON_CLASSIC } from '../../libraries/RadioButtonTheme'
import { getMergedClassNames } from '../../utils/HTMLutils'
import { captalizeFirtLetter } from '../../utils/MaskUtils'
import { secondsToHours } from '../../utils/ParsingUtils'
import Button from '../button/Button'
import Collapse from '../collapse/Collapse'
import IconButton from '../iconButton/IconButton'
import RadioButton from '../radioButton/RadioButton'
import { STATUS_PAUTA_BLOQUEADA } from './../../libraries/Pautas'
import './AssembleiaPauta.scss'

const rootClassName = 'component-assembleia-pauta'

interface AssembleiaPautaProps {
  loading?: boolean
  opened: boolean
  toggleOpened: (evt: any) => void
  titulo: string
  descricao?: string
  status: PautaStatusType
  disabled?: boolean
  readOnly?: boolean
  barIcon: React.ReactNode
  onMostrarResultadosClick: (evt?: any) => void
  mostrarResultadosDisabled?: boolean
  mostrarResultadosIcon?: boolean
  showMostrarResultadosButton?: boolean
  onVoteButtonClick: (idItemVoto?: number | null) => Promise<null>
  voteButtonIcon?: React.ReactNode
  callBackZerouTempo?: () => void
  tempo?: number
  itens?: {
    idItemPauta: number
    descricao: string
    flgAbstencao: number
    representantesChapa: {}[]
    ordem: number
  }[]
  votos?: {
    idItemPauta: number
    idPauta: number
    idEvento: number
    idConvocado: number
    tipo: number
    cpfRepresentante: string
    data: string
  }[]
  language?: {
    opcoesDeVotoLabel: string
    votarLabel: string
    mostrarResultadosLabel: string
    votoEnviadoLabel: string
    itemAbstencaoLabel: string
    seTiverVotosLabel: string
    barLabel: string
    getStatusLabel: (status?: PautaStatusType) => string
    votarNestaPautaLabel: string
    resultadoParialLabel: string
  }
}

AssembleiaPauta.defaultProps = {
  tempo: 0,
  status: STATUS_PAUTA_BLOQUEADA,
  barIcon: '--',
  language: {
    opcoesDeVotoLabel: 'Opções de voto:',
    votarLabel: 'Votar',
    votoEnviadoLabel: 'Voto enviado!',
    itemAbstencaoLabel: 'Abster desta pauta',
    seTiverVotosLabel:
      'Selecione uma opção de voto diferente para alterar o voto',
    barLabel: 'Visualizar pauta',
    getStatusLabel: () => 'Bloqueada',
    votarNestaPautaLabel: 'Votar nesta pauta',
    resultadoParcialLabel: 'Ver resultados parciais'
  }
}

var timeoutFecharSucesso: any = null
function AssembleiaPauta(props: AssembleiaPautaProps) {
  const [mostrarVotoEnviado, setMostrarVotoEnviado] = useState(false)
  const [loadingVoto, setLoadingVoto] = useState(false)
  const [voto, setVoto] = useState<number | null>(null)
  const [votoAtual, setVotoAtual] = useState<number | null>(null)

  const timeLeft = useTimeElapsed(props.tempo!, props.callBackZerouTempo)

  useEffect(() => {
    const idItemPauta = props.votos?.length ? props.votos[0].idItemPauta : null
    setVoto(idItemPauta)
    setVotoAtual(idItemPauta)
  }, [JSON.stringify(props.votos || [])])

  const handleToggle = () => {
    if (typeof props.toggleOpened === 'function') {
      props.toggleOpened(!props.opened)
    }
  }

  const getStatusIcon = () => {
    switch (props.status) {
      case STATUS_PAUTA_LIBERADA:
        return <CheckCircleIcon />
      case STATUS_PAUTA_ENCERRADA:
        return <TimesCircleIcon />
      case STATUS_PAUTA_BLOQUEADA:
        return <LockIcon />
      default:
        return '-'
    }
  }

  const getItemPautaName = (it: any) => {
    if (!it) return ''
    return captalizeFirtLetter(
      it.flgAbstencao ? props.language?.itemAbstencaoLabel : it.descricao
    )
  }

  return (
    <div
      className={getMergedClassNames([
        rootClassName,
        getStatusClassName(props.status),
        props.votos && props.votos.length ? 'tem-voto' : 'sem-voto',
        props.opened ? 'opened' : ''
      ])}
    >
      <div className={`${rootClassName}-header`} onClick={handleToggle}>
        <div className={`${rootClassName}-first-line`}>
          <div className={`${rootClassName}-first-col`}>
            <div className={`${rootClassName}-timer nunito`}>
              {secondsToHours(timeLeft)}
            </div>
            <div className={`${rootClassName}-etiqueta`}>
              <span className='icon'>{getStatusIcon()}</span>
              <span className='label nunito'>
                {captalizeFirtLetter(
                  props.language?.getStatusLabel(props.status)
                )}
              </span>
            </div>
          </div>
          <div
            className={getMergedClassNames([
              `${rootClassName}-arrow`,
              props.opened ? 'cima' : ''
            ])}
          >
            <ChevronArrowDownIcon />
          </div>
        </div>
        <div className={`${rootClassName}-titulo`}>
          {captalizeFirtLetter(props.titulo)}
        </div>
      </div>
      <Collapse opened={Boolean(props.votos?.length && !props.opened)}>
        <div
          className={`${rootClassName}-voto-atual nunito`}
          onClick={handleToggle}
        >
          <RadioButton
            theme={RADIO_BUTTON_CLASSIC}
            value={true}
            disabled={props.disabled}
          />
          {getItemPautaName(props.itens?.find((it) => it.idItemPauta === voto))}
        </div>
      </Collapse>
      <Collapse opened={props.opened}>
        <div className={`${rootClassName}-corpo-pauta`}>
          <div className={`${rootClassName}-descricao`}>
            {captalizeFirtLetter(props.descricao)}
          </div>
          <div className={`${rootClassName}-opcoes-label nunito`}>
            {captalizeFirtLetter(props.language?.opcoesDeVotoLabel)}
          </div>
          <div className={`${rootClassName}-opcoes-de-voto`}>
            {props.itens
              ?.sort((a, b) => a.ordem - b.ordem)
              .map((it, index) => {
                // todo NAME!
                return (
                  <button
                    key={index}
                    className={`${rootClassName}-opcao-de-voto`}
                    onClick={() => setVotoAtual(it.idItemPauta)}
                    disabled={props.disabled}
                  >
                    <div
                      className={getMergedClassNames([
                        'radio',
                        votoAtual === it.idItemPauta ? 'atual' : '',
                        props.disabled ? 'disabled' : ''
                      ])}
                    />
                    <span className='nome nunito'>{getItemPautaName(it)}</span>
                  </button>
                )
              })}
          </div>
          {props.votos?.length && props.status === STATUS_PAUTA_LIBERADA ? (
            <div className={`${rootClassName}-se-tiver-votos nunito`}>
              {props.language?.seTiverVotosLabel}
            </div>
          ) : undefined}
          <div className={`${rootClassName}-actions-line`}>
            {props.showMostrarResultadosButton ? (
              <Button
                disabled={props.mostrarResultadosDisabled}
                leftIcon={props.mostrarResultadosIcon}
                onClick={props.onMostrarResultadosClick}
              >
                {props.language?.mostrarResultadosLabel}
              </Button>
            ) : undefined}
            {props.status === STATUS_PAUTA_LIBERADA ? (
              <Button
                leftIcon={props.voteButtonIcon}
                theme={BUTTON_STYLE_PAUTA}
                loader={{
                  loading: loadingVoto,
                  loaderTheme: 'secondary',
                  loaderSize: 1
                }}
                disabled={props.disabled || voto === votoAtual}
                onClick={() => {
                  setLoadingVoto(true)
                  props
                    .onVoteButtonClick(votoAtual)
                    .finally(() => {
                      setLoadingVoto(false)
                    })
                    .then(() => {
                      setMostrarVotoEnviado(true)
                      timeoutFecharSucesso = setTimeout(() => {
                        setMostrarVotoEnviado(false)
                        props.toggleOpened(false)
                      }, 5000)
                    })
                }}
              >
                Votar
              </Button>
            ) : undefined}
          </div>
        </div>
      </Collapse>
      <Collapse opened={!props.opened}>
        <div className={`${rootClassName}-bottom-bar`} onClick={handleToggle}>
          <span className='icon'>{props.barIcon}</span>
          <span className='label nunito'>
            {captalizeFirtLetter(props.language?.barLabel)}
          </span>
        </div>
      </Collapse>
      <CSSTransition
        in={mostrarVotoEnviado}
        timeout={500}
        classNames='fade'
        mountOnEnter
        unmountOnExit
      >
        <div className={`${rootClassName}-voto-enviado`}>
          <IconButton
            icon={<CloseIcon />}
            className={`${rootClassName}-close-icon`}
            onClick={() => {
              setMostrarVotoEnviado(false)
              props.toggleOpened(false)
              if (timeoutFecharSucesso) clearTimeout(timeoutFecharSucesso)
            }}
          />
          <div className={`${rootClassName}-icon`}>
            <CheckCircleIcon />
          </div>
          <div className={`${rootClassName}-label`}>
            {captalizeFirtLetter(props.language?.votoEnviadoLabel)}
          </div>
        </div>
      </CSSTransition>
    </div>
  )
}

export default memo(AssembleiaPauta)
